<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="title weight-600">{{ $t("My Profile") }}</div>
            </div>
            <div class="buttons">
              <div
                class="button bordered small"
                @click="$parent.openPassModal()"
              >
                {{ $t("Change Password") }}
              </div>
              <div class="button bordered small" @click="$parent.logout">
                {{ $t("Log Out") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section profile-section">
        <div class="wrapper">
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper form-fields-wrapper">
                <div class="title small">
                  <b>{{ $t("Personal Information") }}</b>
                </div>
                <div>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("First name:") }}
                    </div>
                    <input
                      type="text" @input="filterInput($event, 'name')"
                      :placeholder="$t('First name')"
                      v-model="name"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Last name:") }}
                    </div>
                    <input
                      type="text" @input="filterInput($event, 'surname')"
                      :placeholder="$t('Last name')"
                      v-model="surname"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("E-mail:") }}
                    </div>
                    <input
                      type="email" @input="filterInput($event, 'email')"
                      :placeholder="$t('E-mail')"
                      v-model="email"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Nickname:") }}
                    </div>
                    <input
                      type="text" @input="filterInput($event, 'nickname')"
                      :placeholder="$t('Nickname')"
                      v-model="nickname"
                    />
                  </label>
                </div>
                <button class="button small" @click="updateProfileData">
                  <span>{{ $t("Save") }}</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="profileUpdateErrorMessaage">
                    {{ profileUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="profileUpdateSuccessMessaage">
                    {{ profileUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="profile-table" v-if="$parent.orderHistory">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title small">
                <b>{{ $t("Your Orders") }}</b>
              </div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>{{ $t("ID") }}</td>
                      <td>{{ $t("Date/time") }}</td>
                      <td>{{ $t("Item name") }}</td>
                      <td>{{ $t("Total") }}</td>
                      <td>{{ $t("Status") }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.created_at) }}</td>
                      <td>{{ item.title }}</td>
                      <td>
                        <b>{{ item.sum }} {{ item.currency_code }}</b>
                      </td>
                      <td
                        :class="[
                          { green: item.status === 'Accepted' },
                          { white: item.status === 'Processing' },
                        ]"
                      >
                        {{ $t(item.status) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Profile",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      nickname: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
    };
  },
  mounted() {
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.nickname = res.data.nickname;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });
  },
  methods: {
    filterInput(e, field) {
      let value = e.target.value;
      value = value.replace(/[^a-zA-Z0-9\s'-]/g, '');
      value = value.replace(/\s+/g, ' ').trimStart();
      this[field] = value;
    },
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        surname: this.surname,
        nickname: this.nickname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
};
</script>
